export const cartaoStore = {
    namespaced: true,
    state : {
        Cartao: { 
            titular: {
                nomeTitular: ""
            }
        },
    },
    mutations : {
        updateStateCartao(state, payload) {
            state.Cartao = payload;
        },
    },
    actions : {
        updateStateCartao({ state, commit }, data) {
            commit('updateStateCartao', data);
        },
    },
    getters : {
        Cartao: (state, getters) => {
            return state.Cartao;
        },   
    }
}